import { motion } from "framer-motion";

const STEPS = [
  {
    num: "01",
    title: "Appointment-Only Start",
    desc: "Every project begins with a private 1-on-1 discovery — understanding your event, your personality, and your budget. No walk-ins, appointments only.",
  },
  {
    num: "02",
    title: "At Your Home Or Online",
    desc: "In Punjab? I come to your home and style your wedding outfits in person. Outside Punjab? HD virtual consultations, with swatches and looks delivered to you.",
  },
  {
    num: "03",
    title: "Couture Co-Creation",
    desc: "From sherwani or bandhgala to turban draping, juttis, jewellery and embroidery — we choose every single detail together.",
  },
  {
    num: "04",
    title: "Final Trial & The Big Day",
    desc: "A complete trial fitting before the event and final touches on the day — so you can simply enjoy your best moment.",
  },
];

const EASE = [0.16, 1, 0.3, 1];

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="bg-[#FDFBF7] py-24 text-[#141414] lg:py-36"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="mb-20 grid grid-cols-1 gap-8 lg:grid-cols-12">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, ease: EASE }}
            className="text-xs font-semibold uppercase tracking-[0.35em] text-[#B38C43] lg:col-span-3"
          >
            How We Work
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, delay: 0.1, ease: EASE }}
            className="font-serif text-3xl font-medium leading-tight tracking-tight sm:text-4xl lg:col-span-9 lg:text-5xl"
          >
            How We Work —{" "}
            <span className="italic text-[#B38C43]">simple, personal, royal.</span>
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 gap-px bg-[#E5DEC9] md:grid-cols-2">
          {STEPS.map((step, i) => (
            <motion.div
              key={step.num}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.12, ease: EASE }}
              data-testid={`process-step-${i + 1}`}
              className="group relative bg-[#FDFBF7] p-10 transition-colors duration-500 hover:bg-[#F4EFE6] lg:p-14"
            >
              <span className="font-serif text-6xl font-light text-[#E5DEC9] transition-colors duration-500 group-hover:text-[#C5A059]">
                {step.num}
              </span>
              <h3 className="mt-6 font-serif text-xl font-semibold sm:text-2xl">
                {step.title}
              </h3>
              <p className="mt-4 max-w-md text-sm leading-relaxed text-[#686152] sm:text-base">
                {step.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
